import enviro from 'enviro';
// This should include all live prod actions: https://tools.hubteam.com/action-builder/hubspot-actions?filter=LIVE
const HUBSPOT_ACTION_ALLOWLIST = ['Manage communication subscriptions', 'Send WhatsApp message', 'Send SMS message', 'Delete Contact', 'Enroll in a sequence', 'Event notification', 'Send Slack Message', 'Schedule Calendar Event', 'Fire Custom Behavioral Event', 'Set marketing contact status', 'Unenroll from sequence', 'Add to static list', 'Remove from static list'];
const USE_ALLOWLIST_KEY = 'filter-out-test-actions';

/**
 * Filters out "test" actions in QA to make it easier to find actual
 * workflow actions. Enable by setting localStorage item
 * 'filter-out-test-actions' to 'true'. Currently uses an allowlist
 * HUBSPOT_ACTION_ALLOWLIST to determine which actions are "real", but we should
 * improve this in the future.
 *
 * Followup tasks to make this better:
 *
 * https://issues.hubspotcentral.com/browse/AUTOPG-3126
 *
 * https://issues.hubspotcentral.com/browse/AUTOPG-3127
 */
export default function qaOnlyLocalStorageFlagFilterTestActions(response) {
  try {
    if (enviro.isProd() || localStorage && localStorage.getItem(USE_ALLOWLIST_KEY) !== 'true') {
      return response;
    }
  } catch (err) {
    return response;
  }
  const filteredResults = response.results.filter(action => action.metaType !== 'HUBSPOT' || HUBSPOT_ACTION_ALLOWLIST.includes(action.actionName));
  return Object.assign({}, response, {
    results: filteredResults
  });
}